import styles from './VerifyEmail.module.css';

import React from 'react';
import { resendVerificationToken } from 'lib/api/owner_api';
import * as analytics from 'lib/analytics';

export default class VerifyEmail extends React.Component<
  {},
  { sent: boolean }
> {
  timeout: NodeJS.Timeout | null;
  constructor(props: any) {
    super(props);
    this.timeout = null;
    this.state = {
      sent: false,
    };
  }
  componentWillUnmount = () => {
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }
  };
  sendVerification() {
    this.setState({ sent: true });
    resendVerificationToken();
    analytics.commentsVerify();
    // re enable button after 30s
    this.timeout = setTimeout(() => this.setState({ sent: false }), 30 * 1000);
  }

  render() {
    return (
      <div className={styles.VerifyEmail}>
        <span>Verify your email to comment</span>
        {this.state.sent && (
          <div className={styles.VerifyEmailButtonDisabled}>Sent</div>
        )}
        {!this.state.sent && (
          <div
            className={styles.VerifyEmailButton}
            onClick={() => this.sendVerification()}
          >
            Resend
          </div>
        )}
      </div>
    );
  }
}
